var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4255.61,-2.41016 H 1.37891 V 4252 H 4255.61 V -2.41016",
    style: {
      fill: "#42b43b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.883,3740.25 V 3589.7 h 1.238 l 101.203,105 h 1.297 v -656.6 h 144.211 v 857.79 H 445.688 L 312.883,3740.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 903.684,3623.83 c -56.907,0 -98.621,-20.19 -121.446,-59.42 h -1.289 v 213.8 h 248.001 v 117.63 H 649.438 v -483.32 h 131.511 v 19.05 c 0,50.55 22.766,78.41 63.25,78.41 44.297,0 62.063,-30.39 62.063,-77.19 v -207.5 c 0,-45.48 -16.465,-77.13 -60.774,-77.13 -49.304,0 -66.968,32.89 -66.968,83.49 v 107.52 H 646.855 v -97.46 c 0,-130.26 51.887,-213.76 198.633,-213.76 145.508,0 204.932,77.19 204.932,196.1 v 210.02 c 0,135.39 -69.549,189.76 -146.736,189.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1763.08,1375.51 c 5.18,0 9.37,-4.22 9.37,-9.41 v -309.78 c 0,-5.26 -4.19,-9.42 -9.37,-9.42 h -125.37 c -5.22,0 -9.43,4.16 -9.43,9.42 v 309.78 c 0,5.19 4.21,9.41 9.43,9.41 h 125.37",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3139.77,913.891 H 1073.9 c -5.17,0 -9.45,-4.442 -9.45,-9.711 V 777.91 c 0,-5.129 4.28,-9.289 9.45,-9.289 h 2065.87 c 5.09,0 9.47,4.16 9.47,9.289 v 126.27 c 0,5.269 -4.38,9.711 -9.47,9.711",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3139.77,662.922 H 1073.9 c -5.17,0 -9.45,-4.16 -9.45,-9.293 v -126.66 c 0,-5.059 4.28,-9.321 9.45,-9.321 h 2065.87 c 5.09,0 9.47,4.262 9.47,9.321 v 126.66 c 0,5.133 -4.38,9.293 -9.47,9.293",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2746.65,1718.42 c -25.82,20.2 -94.7,67.33 -178.7,67.33 -60.06,0 -115.93,-23.66 -165.91,-70.48 -3.53,-3.36 -5.51,-8.01 -5.51,-12.97 v -11.25 c 0,-5.54 1.83,-10.72 5.87,-14.12 4.5,-3.4 9.2,-4.68 14.57,-3.4 1.19,0.16 2.66,0.54 3.87,0.99 3.82,1.33 7.41,3.63 10.33,6.55 10.84,7.27 40.43,17.21 82.75,17.21 43.75,0 129.75,-11.72 212.85,-89.21 l 1.91,-1.7 c 4.67,-4.81 11.14,-7.48 17.97,-7.48 6.51,0 13.24,2.72 17.48,7.31 l 1.68,1.74 c 83.57,77.62 169.41,89.34 213.17,89.34 42.62,0 72.08,-9.94 82.96,-17.21 2.96,-2.92 6.6,-5.27 11.4,-7 1.84,-0.54 7.1,-1.62 12.11,-0.38 7.64,2.16 13.01,9.04 13.01,17.03 v 9.97 c 0,4.72 -2.04,9.49 -5.55,12.78 -50.45,48.08 -106.91,72.39 -167.92,72.39 -83.23,0 -151.79,-46.41 -178.34,-67.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2618.45,2541.79 c -4.4,-2.04 -7.57,-6.06 -9.01,-10.88 l -2.09,-6.89 c -1.56,-5.42 -0.57,-11.15 2.7,-15.52 3.2,-4.19 7.75,-6.72 12.78,-6.96 0.96,-0.11 1.89,-0.35 2.58,-0.11 3.6,0.11 6.82,0.89 10,2.56 1.83,0.37 5.65,1.38 12.52,1.38 9.24,0 92.53,-2.79 147.59,-96.39 l 0.7,-1.33 c 3,-5.42 7.67,-9.16 13.22,-10.59 1.6,-0.52 4.67,-1.01 6.59,-1.01 3.82,0 7.66,1.01 10.4,2.58 l 1.36,0.65 c 30.13,15.07 61.34,22.79 92.17,22.79 52.18,0 86.25,-21.28 94.21,-30.14 1.62,-3.01 4.1,-5.64 6.92,-7.71 1.75,-1.01 4.85,-2.57 6.7,-3.23 0.94,-0.24 2.03,-0.36 3.06,-0.44 0.57,-0.12 1.24,-0.12 1.86,-0.12 2.81,0 5.52,0.7 8.18,2.06 4.23,2.13 7.41,5.99 8.78,10.59 l 1.73,6.08 c 0.52,1.55 0.72,3.24 0.72,5.03 0,3.22 -0.83,6.35 -2.4,8.87 -40.12,69.67 -98.34,84.23 -140.14,84.23 -31.1,0 -58.32,-8.07 -74.34,-13.96 -18.93,25.45 -66.77,78.07 -139.34,78.07 -25.51,0 -51.51,-6.55 -77.45,-19.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2181.94,2223.96 0.58,-9.3 c 0.29,-5.8 3.33,-10.82 8.26,-13.91 4.09,-2.57 9.3,-3.46 13.9,-2.11 1.01,0.24 2.14,0.61 3.02,0.95 3.56,1.46 6.58,3.72 8.93,6.59 8.78,6.34 37.07,17.89 78.79,17.89 40.12,0 101.15,-10.71 163.35,-61.79 l 1.45,-1.49 c 4.43,-3.83 10.11,-5.99 15.92,-5.99 h 1.53 c 6.5,0.49 12.52,3.49 16.21,7.79 l 1.4,1.56 c 68.84,72.87 143.02,83.7 181.1,83.7 27.13,0 46.37,-5.6 53.86,-9.83 2.83,-2.45 6.34,-4.39 10.73,-5.58 1.24,-0.3 4.29,-0.84 7.57,-0.49 1.33,0.14 3.01,0.61 4.33,1.03 7.39,2.59 12.24,9.79 11.72,17.76 l -0.46,8.08 c -0.31,4.82 -2.56,9.14 -6.22,12.3 -41.1,34.57 -85.46,51.99 -132.14,51.99 -72.66,0 -130.62,-42.91 -154.64,-63.95 -21.97,14.96 -75.28,45.74 -137.84,45.74 -54.96,0 -104.25,-22.83 -146.56,-67.72 -3.33,-3.55 -5.01,-8.38 -4.79,-13.22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1136.5,2058.11 c 0,123.72 100.3,223.96 223.96,223.96 4.85,0 9.58,-0.43 14.36,-0.69 11.79,156.55 142.24,280.02 301.84,280.02 167.38,0 303.07,-135.66 303.07,-303.03 0,-47.41 -11.22,-92.09 -30.65,-132.05 151.68,-33.6 265.2,-168.66 265.2,-330.38 0,-187.02 -151.62,-338.64 -338.64,-338.64 -13.66,0 -451.93,2.63 -451.93,2.63 v 0 c -132.47,0.02 -239.81,107.33 -239.81,239.78 0,63.62 24.94,121.23 65.37,164.17 -67.31,38.63 -112.77,111.03 -112.77,194.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1322.18,3905.38 h 60.42 v -310.02 h 72.07 v -49.29 h -132.49 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1479.58,3905.38 h 144.15 v -49.29 H 1540 v -102.81 h 59.88 v -48.76 H 1540 v -109.16 h 83.73 v -49.29 h -144.15 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1713.84,3707.71 v -112.35 h 26.49 c 20.14,0 29.68,10.07 29.68,29.14 v 54.06 c 0,19.08 -9.01,29.15 -30.2,29.15 z m 0,46.1 h 21.19 c 19.61,0 28.62,10.07 28.62,29.14 v 44 c 0,19.6 -9.01,29.14 -29.15,29.14 h -20.66 z m -60.42,151.57 h 87.44 c 60.42,0 80.56,-28.09 80.56,-78.97 v -36.56 c 0,-30.21 -11.13,-49.29 -36.04,-57.24 30.21,-6.88 45.04,-27.02 45.04,-59.88 v -47.7 c 0,-50.87 -22.78,-78.96 -83.2,-78.96 h -93.8 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1858,3905.38 h 144.14 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 H 1858 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2082.71,3771.83 v -225.76 h -50.87 v 359.31 h 59.35 l 65.18,-206.15 v 206.15 h 50.35 v -359.31 h -53 l -71.01,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1388.43,3160.01 h 48.22 l -23.85,144.14 h -0.52 z m -75.78,-113.93 67.83,359.3 h 68.89 l 68.36,-359.3 h -62.01 l -11.12,65.71 h -64.12 l -10.61,-65.71 h -57.22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1590.88,3271.83 V 3046.08 H 1540 v 359.3 h 59.36 l 65.18,-206.15 v 206.15 h 50.34 v -359.3 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1799.7,3405.38 h 60.42 v -310.03 h 72.07 v -49.27 H 1799.7 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2023.35,3160.01 h 48.22 l -23.84,144.14 h -0.53 z m -75.78,-113.93 67.83,359.3 h 68.9 l 68.36,-359.3 h -62 l -11.14,65.71 h -64.12 l -10.59,-65.71 h -57.24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2225.8,3271.83 v -225.75 h -50.87 v 359.3 h 59.36 l 65.17,-206.15 v 206.15 h 50.36 v -359.3 h -53 l -71.02,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2467.48,3095.35 c 24.9,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.55,36.04 -34.45,36.04 h -25.44 v -260.74 z m 94.86,213.58 v -166.41 c 0,-55.12 -22.79,-96.44 -87.44,-96.44 h -93.27 v 359.3 h 93.27 c 64.65,0 87.44,-40.82 87.44,-96.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe15);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-15.aca1a6b893ed3fdafdb7a364ab893d4f.svg";
export { ForwardRef as ReactComponent };